import $ from 'jquery'

import { Property } from 'types'

// function changeFormat(value) {
//   if (value) {
//     var convert = value.toString()
//     return convert.replace(",", ".")
//   }
// }

//Funcion para listar/eliminar markers en localStorage
export const addMarker = (id: number) => {
  if (localStorage.getItem('markerview')) {
    const storage = localStorage.getItem('markerview')
    var array_storage = storage?.split('-')
    array_storage = array_storage?.filter((element) => element != '')
    if (array_storage?.find((element) => element === id.toString())) {
      // localStorage.setItem("markerview","")
      // var array_new = (array_storage.filter(element => element != id.toString()))
      // for (let index = 0; index < array_new.length; index++) {
      //     localStorage.setItem("markerview", (localStorage.getItem("markerview")  + array_new[index] + "-"))
      // }
      // return null
    } else {
      localStorage.setItem('markerview', localStorage?.getItem('markerview')! + id + '-')
    }
  } else {
    localStorage.setItem('markerview', id + '-')
  }
  return null
}

//Función para checkear un marker
export const checkMarker = (id: string) => {
  var storage = localStorage.getItem('markerview') // Recupero los ids
  if (!storage) {
    localStorage.setItem('markerview', '')
  } // Si no hay nada en el localStorage lo inicializo
  var storageParse = localStorage?.getItem('markerview')?.split('-') // Recupero los ids
  storageParse = storageParse?.filter((element) => element !== '') // Elimino si hay algun espacio vacio
  if (storageParse?.find((element) => element.toString() === id.toString())) {
    return true
  }
  return false
}

// //Funcion para traer todos los markers
// export const getMarkers = () => {
//   var storage = localStorage.getItem("markerview") // Recupero los ids
//   if (!storage) {
//     localStorage.setItem("markerview", "")
//   } // Si no hay nada en el localStorage lo inicializo
//   storage = localStorage.getItem("markerview").split("-") // Recupero los ids
//   storage = storage.filter(element => element !== "") // Elimino si hay algun espacio vacio
//   return storage //Retorno array de ids
// }

export const reCalculateCoordinateMarkers = (data: any) => {
  // return properties;
  if (!data) {
    return []
  }
  let detail_properties = []
  for (const iterator of data) {
    detail_properties.push(iterator)
  }
  for (let index = 0; index < detail_properties.length; index++) {
    //Recorro todas las propiedades
    const property = detail_properties[index]

    let properties_repeat: Property[] = detail_properties.filter(
      (prop) =>
        prop.geo_lat === property.geo_lat &&
        prop.geo_long === property.geo_long &&
        prop.offsetChanged !== true &&
        !prop.development,
    ) // Cantidad de propiedades iguales con la misma coordenada.
    if (properties_repeat.length > 1) {
      const count = properties_repeat.length
      const radius = count > 8 ? 0.0008 : 0.0008 // Radio del círculo
      const angleStep = (2 * Math.PI) / count // Angulo entre cada marcador
      const offsetAngle = Math.PI / count // Offset angular inicial

      const width = 3 // Ancho de la cuadrícula
      for (let i = 0; i < properties_repeat.length; i++) {
        let property_repeat = properties_repeat[i]

        let angle = offsetAngle + i * angleStep
        const offsetX = radius * Math.cos(angle)
        const offsetY = radius * Math.sin(angle)
        if (
          property_repeat?.development === null ||
          property_repeat?.development === undefined ||
          property_repeat?.development?.display_on_web === false
        ) {
          const converted = Object.assign({}, property_repeat, {
            offsetChanged: true,
            countProperties: new Array(count).fill(null),
            geo_long_changed: parseFloat(changeFormat(property_repeat?.geo_long)!) + offsetX,
            geo_lat_changed: parseFloat(changeFormat(property_repeat?.geo_lat)!) + offsetY,
          })

          detail_properties = detail_properties.filter(
            (element) => element.id !== property_repeat.id,
          )
          detail_properties.push(converted)
        }
      }
    }
  }

  return detail_properties
}

export function changeFormat(value: string | undefined) {
  if (value) {
    var convert = value.toString()
    return convert.replace(',', '.')
  }
}

// //Function to center map smoothly and zoom in

var panPath: any = [] // An array of points the current panning action will use
var panQueue: any = [] // An array of subsequent panTo actions to take
var STEPS = 300 // The number of steps that each panTo action will undergo

export const handlerClick = (newLat: any, newLng: any, mapRef: any, isLeaflet: boolean) => {
  if (isLeaflet) {
    mapRef.setView([newLat, newLng], 16, { animation: true })
    return null
  }

  if (panPath.length > 0) {
    panQueue.push([newLat, newLng])
    return
  }
  // Lets compute the points we'll use
  panPath.push('LAZY SYNCRONIZED LOCK') // make length non-zero - 'release' this before calling setTimeout
  const curLat = mapRef.getCenter().lat()
  const curLng = mapRef.getCenter().lng()
  // const curLat = mapRef.current.getCenter().lat()
  // const curLng = mapRef.current.getCenter().lng()
  const dLat = (newLat - curLat) / STEPS
  const dLng = (newLng - curLng) / STEPS

  for (var i = 0; i < STEPS; i++) {
    panPath.push([curLat + dLat * i, curLng + dLng * i])
  }
  panPath.push([newLat, newLng])
  panPath.shift() // LAZY SYNCRONIZED LOCK
  // setTimeout(doPan(mapRef), 20)
  doPan(mapRef)
}

export const doPan = (mapRef: any) => {
  const next = panPath.shift()
  if (next != null) {
    mapRef?.panTo(new window.google.maps.LatLng(next[0], next[1]))
    // setTimeout(doPan(mapRef), 20)
    doPan(mapRef)
  } else {
    const queued = panQueue.shift()
    if (queued != null) {
      // panTo(queued[0], queued[1])
    }
  }
}

export const deleteSharp = (draw: any, dispatch: any, action: any) => {
  draw?.setMap(null)
  dispatch(action(null))
}

export function getLatLang(latitude: number, longitue: number): google.maps.LatLngLiteral {
  const center: { lat: number; lng: number } = {
    lat: parseFloat(latitude.toString()),
    lng: parseFloat(longitue.toString()),
  }
  return center
}

export const scrollOnGrid = (id: string) => {
  const sideBarElement = document.getElementById('sidebarElement') // get id of sidebar
  const cardSelectedElement = $('#card-grid-' + id).last() // get id of card
  var offsetCard = cardSelectedElement?.position()?.top // get offset of card
  if (sideBarElement) {
    sideBarElement.scrollTo({
      top: sideBarElement.scrollTop + offsetCard - 300,
      behavior: 'smooth',
    }) // scroll to card
  }
}

export const thisMarkerIsDevelopment = (
  cluster: { property: { development: { display_on_web: any; id: any } | null } },
  searchUnitiesInResults: any,
) => {
  return (
    cluster.property.development !== null && cluster.property.development.display_on_web
    // && searchUnitiesInResults(cluster.property.development?.id)?.length > 0
  )
}
// the smooth zoom function
export function smoothZoomIn(map: any, max: number, cnt: number) {
  if (cnt >= max) {
    return
  } else {
    const z = google.maps.event.addListener(map, 'zoom_changed', function (event: any) {
      google.maps.event.removeListener(z)
      smoothZoomIn(map, max, cnt + 1)
    })
    setTimeout(function () {
      map.setZoom(cnt)
    }, 150) // 80ms is what I found to work well on my system -- it might not work well on all systems
  }
}

export function smoothZoomOut(map: any, max: number, cnt: number) {
  if (cnt <= max) {
    return
  } else {
    const z = google.maps.event.addListener(map, 'zoom_changed', function (event: any) {
      google.maps.event.removeListener(z)
      smoothZoomOut(map, max, cnt - 1)
    })
    setTimeout(function () {
      map.setZoom(cnt)
    }, 150) // 80ms is what I found to work well on my system -- it might not work well on all systems
  }
}
